import React, { Component } from "react";
import {
  YAxis,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  Brush,
  CartesianGrid
} from "recharts";
import { valueConverter_2 } from '../../../util-functions/util-funtions'
import "./inner.scss";
import { generateF_C_A_C_LineGraph } from ".././../../util-functions/util-funtions";

const style_ = {
  width: "auto",
  padding: "10px",
  backgroundColor: "white",
  boxShadow:'0 2px 3px 0 rgba(0, 0, 0, 0.1)'
};


class Forcast_actual_line_graph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    if (this.props.data) {
      let myArr = generateF_C_A_C_LineGraph(this.props.data)
      this.setState({
        data: myArr
      })
    }
  }

  CustomTooltip = ({ active, payload, label }) => {
    if (active) {
      return (
        <div className="custom-tooltip" style={style_}>
          <p className="label">
            {label}</p>
          <p className="label" style={{ color: '#219EBC' }}>{`${'AgreedBaselineForecast'
            } : ${valueConverter_2(payload[0]?.payload.AgreedBaselineForecast?.toFixed(2))}`}</p>
          <p className="label" style={{ color: '#63993D' }}>{`${'CustomerPromotionEDLP'
            } : ${valueConverter_2(payload[0]?.payload.CustomerPromotionEDLP?.toFixed(2))}`}</p>
          <p className="label" style={{ color: '#8A614B' }}>{`${'CustomerPromotionSBB'
            } : ${valueConverter_2(payload[0]?.payload.CustomerPromotionSBB?.toFixed(2))}`}</p>
          <p className="label" style={{ color: '#0353A4' }}>{`${'CustomerPromotionTPR'
            } : ${valueConverter_2(payload[0]?.payload.CustomerPromotionTPR?.toFixed(2))}`}</p>
          <p className="label" style={{ color: '#F8BF06' }}>{`${'HolidaysDIP'
            } : ${valueConverter_2(payload[0]?.payload.HolidaysDIP?.toFixed(2))}`}</p>
          <p className="label" style={{ color: '#C44536' }}>{`${'Others'
            } : ${valueConverter_2(payload[0]?.payload.Others?.toFixed(2))}`}</p>
            <p className="label" style={{ color: '#E57D2F' }}>{`${'UnconstraintDemand'
              } : ${valueConverter_2(payload[0]?.payload.UnconstraintDemand?.toFixed(2))}`}</p>
        </div>
      );
    }else{
      return ''
    }
  };
  render() {
    // if (this.props.weekly) {
      return (
          <ResponsiveContainer height="100%" width="100%">
            <LineChart
              width={7200}
              height={280}
              data={this.state.data}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <YAxis axisLine={{ stroke: '#e6e6e7' }} tickLine={false} padding={{ top: 10 }} />
              <XAxis dataKey="name" style={{ fontSize: "11px" }} interval={1} axisLine={{ stroke: '#e6e6e7' }} tickLine={false} />
              <Tooltip content={this.CustomTooltip} />
              <CartesianGrid vertical={false} />
              <Brush stroke="#3f7fc9">
                    <LineChart data={this.state.data}>
                        <XAxis
                            dataKey="name"
                            padding={{ left: 0, right: 0 }}
                            axisLine={false}
                            tick={true}
                            tickLine={false}
                            tickSize={10}
                            fontSize={10}
                            domain={["dataMin", "dataMax "]}
                            interval={1}
                        />
                    </LineChart>
                </Brush>
              {this.props.myAgreedBaselineForecast ?
                <Line
                  type="monotone"
                  dataKey='AgreedBaselineForecast'
                  stroke="#219EBC"
                  dot={false}
                  strokeWidth={2}
                >
                </Line>
                :
                null
              }
              {this.props.myCustomerPromotionEDLP ?
                <Line
                  type="monotone"
                  dataKey='CustomerPromotionEDLP'
                  stroke="#63993D"
                  dot={false}
                  strokeWidth={2}
                >
                </Line>
                :
                null
              }
              {this.props.myCustomerPromotionSBB ?
                <Line
                  type="monotone"
                  dataKey='CustomerPromotionSBB'
                  stroke="#8A614B"
                  dot={false}
                  strokeWidth={2}
                >
                </Line>
                :
                null
              }
              {this.props.myCustomerPromotionTPR ?
                <Line
                  type="monotone"
                  dataKey='CustomerPromotionTPR'
                  stroke="#0353A4"
                  dot={false}
                  strokeWidth={2}
                >
                </Line>
                :
                null
              }
              {this.props.myHolidaysDIP ?
                <Line
                  type="monotone"
                  dataKey='HolidaysDIP'
                  stroke="#F8BF06"
                  dot={false}
                  strokeWidth={2}
                >
                </Line>
                :
                null
              }
              {this.props.myOthers ?
                <Line
                  type="monotone"
                  dataKey='Others'
                  stroke="#C44536"
                  dot={false}
                  strokeWidth={2}
                >
                </Line>
                :
                null
              }
              {this.props.myUnconstraintDemand ?
                <Line
                  type="monotone"
                  dataKey='UnconstraintDemand'
                  stroke="#E57D2F"
                  dot={false}
                  strokeWidth={2}
                >
                </Line>
                :
                null
              }
            </LineChart>
          </ResponsiveContainer>
      );
    // }
    // else {
    //   return (
    //     <div id='div12' style={{ width: "85%", overflowX: 'hidden', marginLeft: '130px', height: '100%' }}>
    //       <ResponsiveContainer height="95%" width="200%">
    //         <LineChart
    //           width={7200}
    //           height={280}
    //           data={this.state.data}
    //           margin={{
    //             top: 5,
    //             right: 30,
    //             left: 20,
    //             bottom: 5,
    //           }}
    //         >
    //           <YAxis axisLine={{ stroke: '#e6e6e7' }} tickLine={false} padding={{ top: 10 }} />
    //           <XAxis dataKey="name" style={{ fontSize: "11px" }} axisLine={{ stroke: '#e6e6e7' }} tickLine={false} />
    //           <Tooltip content={this.CustomTooltip} />
    //           <Brush/>
    //           {this.props.myForecast ?
    //             <Line
    //               type="monotone"
    //               dataKey='forecast'
    //               stroke="#58a2c9"
    //               dot={false}
    //               strokeWidth={2}
    //             >
    //               <LabelList content={<CustomizedLabel myProps={this.state.data ? this.state.data : []} />} position="insideTop" />
    //             </Line>
    //             :
    //             null
    //           }
    //           {this.props.myActual ?
    //             <Line
    //               type="monotone"
    //               dataKey='actual'
    //               stroke="#6ea943"
    //               dot={false}
    //               strokeWidth={2}
    //             >
    //               <LabelList content={<CustomizedLabel myProps={this.state.data ? this.state.data : []} />} position="insideTop" />
    //             </Line>
    //             :
    //             null
    //           }
    //           {this.props.mySecondarySale ?
    //             <Line
    //               type="monotone"
    //               dataKey='secondarySale'
    //               stroke="#ed7708"
    //               dot={false}
    //               strokeWidth={2}
    //             >
    //               <LabelList content={<CustomizedLabel myProps={this.state.data ? this.state.data : []} />} position="insideTop" />
    //             </Line>
    //             :
    //             null
    //           }
    //         </LineChart>
    //       </ResponsiveContainer>
    //     </div>
    //   );
    // }
  }
}
export default Forcast_actual_line_graph;
